export async function parseResponseData<T = unknown>(response: Response): Promise<T | undefined | string> {
  const responseText = await response.text();

  if (!responseText) {
    return undefined;
  }

  try {
    return JSON.parse(responseText);
  } catch {
    return responseText;
  }
}
